const INSIGHTS_URL = "https://api.openpanel.dev/insights";
const EXPORT_URL = "https://api.openpanel.dev/export";
const PROJECT_ID = process.env.REACT_APP_OPENPANEL_PROJECT_ID;
const CLIENT_ID = process.env.REACT_APP_OPENPANEL_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_OPENPANEL_CLIENT_SECRET;

const headers = {
  "openpanel-client-id": CLIENT_ID,
  "openpanel-client-secret": CLIENT_SECRET,
};

// type "venue" -> /l/{slug}/{id}, type "service" -> /d/{slug}/{id}
export async function fetchVenueMetrics(slug, objectID, range = "30d", type = "venue") {
  const base = type === "service" ? "/d" : "/l";
  const pathPrefix = `${base}/${slug}/${objectID}`;
  const filters = JSON.stringify([
    { name: "path", operator: "startsWith", value: [pathPrefix] },
  ]);

  const params = new URLSearchParams({ range, filters });
  const url = `${INSIGHTS_URL}/${PROJECT_ID}/metrics?${params}`;

  const res = await fetch(url, { headers });
  if (!res.ok) throw new Error(`OpenPanel API error: ${res.status}`);
  return res.json();
}

// Diensten tag events with properties.service_id, venues with properties.venue_id.
export async function fetchEventCount(objectID, eventName, range = "30d", type = "venue") {
  const idProp = type === "service" ? "properties.service_id" : "properties.venue_id";
  const series = JSON.stringify([{
    name: eventName,
    segment: "event",
    filters: [{ name: idProp, operator: "is", value: [objectID] }],
  }]);

  const params = new URLSearchParams({ projectId: PROJECT_ID, series, range, interval: "day" });
  const url = `${EXPORT_URL}/charts?${params}`;

  const res = await fetch(url, { headers });
  if (!res.ok) throw new Error(`OpenPanel API error: ${res.status}`);
  const data = await res.json();
  return data.metrics?.sum || 0;
}
